// extracted by mini-css-extract-plugin
export var bannerSection = "IncommOfferLayout-module--bannerSection--6880d";
export var contentSection = "IncommOfferLayout-module--contentSection--ba14f";
export var footerSection = "IncommOfferLayout-module--footerSection--60349";
export var incommOfferLayout = "IncommOfferLayout-module--incommOfferLayout--efb42";
export var incommOfferLayoutFullWidth = "IncommOfferLayout-module--incommOfferLayoutFullWidth--e1830";
export var layoutInner = "IncommOfferLayout-module--layoutInner--27731";
export var layoutInnerConstrained = "IncommOfferLayout-module--layoutInnerConstrained--1b4c6";
export var stepContent = "IncommOfferLayout-module--stepContent--5c1f9";
export var stepContentFullWidth = "IncommOfferLayout-module--stepContentFullWidth--4ab8f";
export var supportSection = "IncommOfferLayout-module--supportSection--e110f";
export var termsSection = "IncommOfferLayout-module--termsSection--34f01";